function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 10px;\n  ",
        "\n  @media ",
        " {\n    flex-direction: column;\n    align-items: flex-start;\n    min-height: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n  color: #707478;\n  font-size: 13px;\n  width: 125px;\n  flex-shrink: 0;\n  text-align: right;\n  padding-right: 35px;\n  @media ",
        " {\n    text-align: left;\n    margin: 10px 0px 3px 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { Flex } from 'rebass';
import { mediaQueries } from 'shared/styles';
import { position } from 'styled-system';
import ModalContainer from './container';
import ModalSecondaryHeader from './header';
import ModalClose from './close';
import ModalButton from './button';
import ModalCopy from './copy';
import FloatingModalCloseButton from './floating-close-button';
import { NotifyBlock, WhiteNotifyBlock, YellowNotifyBlock, RedNotifyBlock } from './notify-block';
import ModalPrimaryHeader from './fancy-header';
var ElementContainer = styled(Flex)(_templateObject(), position, mediaQueries.largePhone);
var Label = styled.p(_templateObject1(), mediaQueries.largePhone);
export { ModalContainer, ModalSecondaryHeader, ModalPrimaryHeader, ModalClose, ModalButton, ModalCopy, FloatingModalCloseButton, ElementContainer, Label, NotifyBlock, WhiteNotifyBlock, YellowNotifyBlock, RedNotifyBlock };
